import React from 'react'
import { useHistory } from 'react-router-dom'

import { View, Button } from 'lib/components'
import ICommonCartridgeCharacterizationReport from 'domains/commonCartridge/models/ICommonCartridgeCharacterizationReport'
import ICharacterization from 'domains/characterizations/models/ICharacterization'
import { getCharacterizationRoute } from 'domains/characterizations/navigation/routes'
import WidgetHeader from 'domains/dashboard/components/WidgetHeader'
import CommonCartridgeCharacterizationReportResourcesList from 'domains/commonCartridge/components/CommonCartridgeCharacterizationReport/CommonCartridgeCharacterizationReportResourcesList'

interface IProps {
  report: ICommonCartridgeCharacterizationReport
  characterization: ICharacterization
}

export default function CCCharcterizationReportResourcesPreview(props: IProps) {
  const history = useHistory()

  const onSeeAll = () => {
    const route = getCharacterizationRoute(
      props.characterization.id,
      props.characterization.format,
      ['resources'],
    )
    history.push(route)
  }

  return (
    <View variant="paper" flexible="column" mt={2}>
      <View flexible="row-space-between">
        <WidgetHeader title="Resources" />
        <Button variant="ccReportBlue500" onClick={onSeeAll}>
          See All
        </Button>
      </View>

      <View mt={3}>
        <CommonCartridgeCharacterizationReportResourcesList
          isPreview={true}
          report={props.report}
          characterization={props.characterization}
        />
      </View>
    </View>
  )
}
